import React from 'react'
import Link from 'gatsby-link'
import { withPrefix } from 'gatsby-link'

import { lang } from '../language'


class ContentSectionHeader extends React.Component {
  render() {
    const intro = this.props.intro
    const handleImageLoaded = this.props.handleImageLoaded

    return (
      <header className="section-header">
        <h1 className="section-title">{ intro['title' + lang] }</h1>
        <p className="section-description">{ intro['description' + lang] }</p>
        { intro.image && <img className="section-image" onLoad={ handleImageLoaded } src={ `${__PATH_PREFIX__}/${intro.url}/${intro.image}.png` }/> }
        <p className="section-show" onClick={ this.unfold }><i className="material-icons">keyboard_arrow_down</i></p>
      </header>
    )
  }

  unfold() {
    document.querySelector('.section-show').classList.remove('state-active')
    document.querySelector('.section-header').classList.add('state-active')
  }
}

class ContentSection extends React.Component {
  render() {
    const data = this.props.data
    console.log(data)

    return (
      <div>
        <ContentSectionHeader
          intro={ data.allTranslationsXlsxSections.edges[0].node }
          handleImageLoaded={ this.handleImageLoaded.bind(this) }
        />

        {data.allTranslationsXlsxContent.edges.map(({ node }, index) =>
          <article className="setting" key={ index }>
            <p className="setting__title"><span className="setting__number">{ index + 1 }.</span> { node['setting' + lang] }</p>
            <p className="setting__description">{ node['description' + lang] }</p>
            { node.image && <img className="setting__image" src={ `${__PATH_PREFIX__}/${node.key}/${node.image}.png` }/> }
          </article>
        )}
      </div>
    )
  }

  handleImageLoaded() {
    const showElem = document.querySelector('.section-show')
    const headerPos = document.querySelector('.section-header').getBoundingClientRect()
    const imagePos = document.querySelector('.section-image').getBoundingClientRect()

    headerPos.height < imagePos.height && showElem.classList.add('state-active')
  }
}

export default ContentSection

export const query = graphql`
  query TestQuery($key: String!) {
    allTranslationsXlsxContent(filter: { key: { eq: $key } }) {
      edges {
        node {
          setting
          description
          setting_nl
          description_nl
          setting_de
          description_de
          key
          image
        }
      }
    }
    allTranslationsXlsxSections(filter: { url: { eq: $key } }) {
      edges {
        node {
          title
          description
          title_nl
          description_nl
          title_de
          description_de
          image
          url
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/content-section.js